import React, { useState } from "react";
import * as linkify from "linkifyjs";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { Button, Form, InputGroup } from "react-bootstrap";

import JsonCollapse from "../Builder/Components/JsonCollapse";
import InputLabel from "../Builder/nodes/Logic/Inputs/InputLabel";
import HelpButton from "../HelpContent/HelpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faX } from "@fortawesome/free-solid-svg-icons";

export interface ShortlinksType {
  uuid: string;
  startingWith: string[];
  expiresAfterVisits: number;
  expireAfterDays: number;
  expires: string;
  isProtected: boolean;
  password: string;
}

export default function Shortlinks({
  shortlinks,
  setShortlinks,
  links,
}: {
  links: any[];
  shortlinks: ShortlinksType;
  setShortlinks: (v: ShortlinksType) => void;
}) {
  const [passwordPeek, setPasswordPeek] = useState(false);

  return (
    <div className="p-3">
      <div className="mt-2">
        <div className="mb-2">
          The following URLs have been identified in your message. Please select
          from the list or enter new one.
        </div>
        <Input
          value={shortlinks.startingWith}
          isMulti
          inputType="select"
          isValidNewOption={(v: string) => linkify.test(v)}
          options={links.map((l) => ({
            value: l.value,
            label: l.value,
          }))}
          onChange={(v: string[]) => {
            setShortlinks({
              ...shortlinks,
              startingWith: v,
            });
          }}
        />
      </div>
      <div className="row my-3">
        <div className="col-4">
          <label htmlFor="" className="form-label">
            Expire after visits
          </label>
          <input
            type="number"
            className="form-control"
            min={0}
            value={shortlinks.expiresAfterVisits}
            onChange={(e) =>
              setShortlinks({
                ...shortlinks,
                expiresAfterVisits: parseInt(e.target.value, 10),
              })
            }
          />
        </div>
        <div className="col-4">
          <label htmlFor="" className="form-label">
            Expire after days
          </label>
          <input
            type="number"
            className="form-control"
            min={0}
            value={shortlinks.expireAfterDays}
            onChange={(e) =>
              setShortlinks({
                ...shortlinks,
                expireAfterDays: parseInt(e.target.value, 10),
              })
            }
          />
        </div>
        <div className="col-4">
          <label htmlFor="" className="form-label">
            Expiry date
          </label>
          <Input
            inputType="dateTime"
            dateTimeType="date"
            value={[shortlinks.expires]}
            onChange={(v: string[]) => {
              setShortlinks({
                ...shortlinks,
                expires: v[0],
              });
            }}
            options={undefined}
          />
        </div>
      </div>
      <div className="row my-3">
        <div className="col-4">
          <div>
            <label htmlFor="" className="form-label">
              {" "}
            </label>
          </div>
          <div className="d-flex align-items-center py-3">
            <Form.Check
              className="fs-5"
              type="switch"
              id="shortlinks-password-switch"
              checked={shortlinks.isProtected}
              onChange={(e) =>
                setShortlinks({
                  ...shortlinks,
                  isProtected: !shortlinks.isProtected,
                })
              }
            />
            <label className="ms-2" htmlFor="shortlinks-password-switch">
              Password protect links
            </label>
          </div>
        </div>
        <div className="col-8">
          <label htmlFor="" className="form-label">
            Password
          </label>
          <InputGroup>
            <input
              type={passwordPeek ? "text" : "password"}
              className="form-control"
              disabled={!shortlinks.isProtected}
              value={shortlinks.password}
              onChange={(e) =>
                setShortlinks({
                  ...shortlinks,
                  password: e.target.value,
                })
              }
            />
            <Button
              variant="outline-secondary"
              onClick={() => setPasswordPeek(!passwordPeek)}
            >
              {passwordPeek ? (
                <FontAwesomeIcon icon={faEye} />
              ) : (
                <FontAwesomeIcon icon={faEyeSlash} />
              )}
            </Button>
          </InputGroup>
        </div>
      </div>{" "}
      <JsonCollapse json={shortlinks} />
    </div>
  );
}
